export default function PublicHeader() {
    return (
        <div className="topbar-image bg-dark py-8 rounded-0 mb-0 alert fade show" role="alert">
            <div className="d-flex justify-content-end gap-sm-3 gap-2 align-items-right text-right flex-md-nowrap flex-wrap">
                <span className="mb-0 text-white fw-bold px-2"><i className="fas fa-phone me-2"></i>(754) 702-0360</span>
                <p className="mb-0 text-white fw-bold"><i className="fas fa-envelope me-2"></i>info@brokersync360.com</p>
            </div>
        </div>
    );
}